<template>
  <div class="about-vadim-wrapper">
    <header class="heading">
      <h2>Вадим Качан</h2>
      <p class="persona-summary">Ювелир, дизайнер, фотограф.</p>
    </header>
    <div class="about-vadim">
      <div class="about-vadim-image">
        <img
          class="vadim-portrait"
          v-if="vadimPortraitImage"
          v-lazy="vadimPortraitImage.image"
          v-bind:alt="vadimPortraitImage.alt_text"
        >
      </div>
      <div class="about-vadim-description">
        <div class="text-block">
          <p>
            Вадим Качан – белорусский ювелир, дизайнер ювелирных украшений
            и фотограф из Бреста.
          </p>
          <p>
            Вадим родился в 1970 году, работает ювелиром и дизайнером с 1992 года.
            В результате многолетней продуктивной деятельности в 2007 году он был
            назначен директором ювелирной мастерской. В 2008 году Вадим открыл
            свою собственную ювелирную фирму «Стиль», в которой он остается
            главным дизайнером и по сей день.
          </p>
          <p>
            Вадим известен как создатель уникального миниатюрного кольца с
            бриллиантом, по видимому, являющимся самым маленьким кольцом в мире.
            В декабре 2019 года он смастерил кольцо из белого и желтого золота
            с бриллиантом размера 1 мм диаметром 2 мм и весом 0.01 гр.
            Уникальность ювелирного изделия состоит в том, что оно по своим
            пропорциям в точности соответствует реальным, полноразмерным аналогам.
            Процесс создания украшения занял 3 дня, однако подготовка, осмысление,
            подбор материалов и инструментов занял несколько месяцев.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutTeamVadimSummary',
  props: ['vadim-portrait-image'],
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .about-vadim-wrapper {
    background-color: $default-background-color;
    @include page-block-vertical-padding($padding-print: 2em);
    @media only print { page-break-after: always; }

    .heading {
      margin-bottom: 0.5em;
      @media only print { margin-bottom: 1.5em; }
      & > .persona-summary {
        font-family: "Baskerville Italic", $font-stack;
        line-height: normal;
        margin-bottom: 0;
        .wf-baskervilleitalic-n4-active & { font-size: 1.5em; }
      }
    }

    .about-vadim {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      @media only print {
        display: block;
      }

      & > .about-vadim-image {
        @include media (">tablet") { flex-basis: 45%; }
        @include media ("<=tablet") { flex-basis: 100%; }
        @media only print {
          float: left;
          padding: 0 1em 1em 0;
        }
        & > img {
          display: block;
          max-width: 100%;
          @include media (">tablet") {
            max-height: 80vh;
            margin-left: auto;
          }
          @include media ("<=tablet") { margin: 0 auto; }
          @media only print {
            max-width: 90%;
            max-height: 50vh;
          }
        }
      }
      & > .about-vadim-description {
        @include media (">tablet") { flex-basis: 55%; }
        @include media ("<=tablet") { flex-basis: 100%; }
        & > .text-block {
          @include text-block();
          @include media (">tablet") { margin-left: 0 !important; }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/AboutTeamVadimSummary.vue